<template >
  <div id="root_page">
      <el-menu
          default-active="2"
          class="nav_header"
          mode="horizontal"
          @select="headerHandle"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b">

          <el-avatar class="headView"
                     :class="!isCollapse?'':'headView_scale'"
                     :size="55"
                     src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
        <el-menu-item
                      v-for="item in menuList"
                      :key="item.index"
                      :index="item.index+''"
                      :route="item.path"
                      :disabled="item.disabled"
                      :class="item.style?item.style:''"
                      :title="item.disabled?'功能开发中...':''"
                      >{{item.name}}</el-menu-item>

        <el-submenu index=""
                    class="right_item"
                    title="功能开发中..."
        >
          <template slot="title">
            <span>账号设置</span>
          </template>
          <el-menu-item :index="6+''">
              修改密码
          </el-menu-item>
          <el-menu-item :index="7+''">
              注销账号
          </el-menu-item>
        </el-submenu>
      </el-menu>
      <el-container>
          <transition name="aside">
            <el-aside
                width="200px"
                v-show="!isCollapse"
            >
              <el-menu
                  default-active="1"
                  class="nav_aside"
                  @select="asideHandle"
                  background-color="#545c64"
                  text-color="#fff"
                  active-text-color="#ffd04b">

                <el-submenu :index="item.index"
                            :key="item.index"
                            v-if="item.children"
                            v-for="item in sideList">
                  <template slot="title">
                    <i :class="item.iconPath"></i>
                    <span>{{item.name}}</span>
                  </template>
                  <el-menu-item
                      v-for="(child,i) in item.children"
                      :index="item.index+'-'+(i+1)"
                      :key="item.index+'-'+(i+1)"
                  >{{child.name}}</el-menu-item>
                </el-submenu>

                <el-menu-item :index="item.index"
                              :key="item.index"
                              v-if="!item.children"
                              v-for="item in sideList">
                  <i :class="item.iconPath"></i>
                  <span slot="title">{{item.name}}</span>
                </el-menu-item>
              </el-menu>
            </el-aside>
          </transition>
          <el-container class="main" :class="isCollapse?'main_scale':''">
            <el-main>
              <router-view></router-view>
            </el-main>
            <el-footer>
              <div class="footer_page">
                <span>©  昆山克鲁克机电设备有限公司 版权所有.&nbsp;&nbsp;&nbsp;
                  <a href="https://beian.miit.gov.cn/#/Integrated/index">皖ICP备20002011号</a></span>
              </div>
            </el-footer>
          </el-container>
      </el-container>
      <add-model v-show="openAddModel"></add-model>
  </div>
</template>

<script>
import {mapMutations} from "vuex";
import addModel from "@/pages/addModel";
import {mapState} from "vuex";
export default {
  name: `navigation`,
  components:{
    addModel,
  },
  data() {
    return {
      menuList:[
        {index:'1',name:'产品查询',disabled: true},
        {index:'2',name:'模型管理',},
        {index:'3',name:'统计分析',disabled:true},
        {index:'4',name:'用户管理',disabled:true},
        {index:'5',name:'退出登录',style:'right_item'},
      ],
      sideList:false,
      product:[
        {index:'1',name:'隔离开关',iconPath:'el-icon-open',routeName:'Modelparam',get type(){return this.name}},
        {index:'2',name:'熔断器',iconPath:'el-icon-s-open',routeName: 'Modelparam',get type(){return this.name}},
        {index:'3',name:'其他',iconPath:'el-icon-position',routeName:'Modelparam',get type(){return this.name}},
      ],
      modelTypeList:[],
      userManage:[
        {index:'1',name:'新增用户',iconPath:'el-icon-circle-plus-outline',routeName:'AddUser'},
        {index:'2',name:'角色管理',iconPath:'el-icon-user',routeName:'RoleManage'},
        {index:'3',name:'用户查询',iconPath:'el-icon-search',routeName:'UserList'},
        {index:'4',name:'黑名单管理',iconPath:'el-icon-document-delete',routeName:'Blacklist'},
      ],
      analysis:[
        {
          index:'1',
          name:'用户分析',
          iconPath:'el-icon-user-solid',
          children:[
            {name:'活跃分析',routeName:'Analysis',type:'active'},
            {name:'时段分析',routeName:'',type:'time'},
          ]
        },
        {
          index:'2',
          name:'订单分析',
          iconPath:'el-icon-tickets',
          children:[
            {name:'订单统计',routeName:''},
            {name:'隔离开关',routeName:''},
            {name:'熔断器',routeName:''},
          ]
        },
      ],
      isCollapse:true,
      lastKey:'-1',
      lastSideKey:'-1',
      openDialog:false,
    };
  },
  methods: {
    headerHandle(key) {
      if(key===this.lastKey&&this.sideList){
        this.isCollapse=!this.isCollapse;
      }else{
        this.lastKey = key;
        let sideKey = '1';//模拟侧栏点击的key
        let menu = this.menuList.filter(item =>item.index === key)
        if (menu.length>0){//有有子菜单的修改标题
          let title = menu[0].name
          this.setPageTitle(title);
        }
        switch (key) {
          case '1':
            this.sideList = this.product;
            break;
          case '2':
              this.$router.replace({name: 'ModelManage', query: {type:'drawing'}});
            break;
          case '3':
            sideKey = '1-1'
            this.sideList = this.analysis;
            break;
          case '4':
            this.sideList = this.userManage;
            break;
          case '5':
            this.sideList = false;
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            console.log('清除token');
            this.toPage('/home');
            break;
          case '6'://修改密码
            this.sideList = false;
            this.setPageTitle('修改密码')
            this.$router.replace('modifyPassword');
            break;
          case '7'://注销账号
            this.sideList = false,
            this.setPageTitle('注销账号')
            this.$router.replace('ofAccount');
            //对话框，访问请求
            break;
        }
        if(this.sideList){
          this.isCollapse = false;
          this.asideHandle(sideKey,true);
        }else{
          this.isCollapse = true;
        }
      }
    },
    /**
     * 有子集返回子集的路由名和路由路径，无子集返回其自身的路由名和路由路径。
     * @param  object
     * @param  key
     * @returns {{query: {type: (*|string)}, name: (string|*)}}
     */
    getRouteParam(object,key){
      let item,index;
      if (typeof key==="string"&&key.length>2){
        let split = key.indexOf('-');
        index = key.slice(0,split) -1;//第一个数字
        let i = key.slice(split+1) -1;//第二个数字
        item = object[index].children[i];
      }else{
        let index = key - 1;
        item = object[index];
      }
       return {name: item.routeName, query: {type:item.type?item.type:'',modelType:item.name,images:item.img}};
    },
    asideHandle(key,focus) {//key,key值与上次相同不加载路由，focus，强制加载路由
      if(this.lastSideKey!==key||focus){
        let param = this.getRouteParam(this.sideList,key)
        console.log('key:',key, 'param:',param);
        this.$router.replace(param);
      }
      this.lastSideKey = key;
    },
    ...mapMutations(['toPage','setPageTitle'])
  },
  computed:{
    ...mapState(['openAddModel'])
  },
  created(){
    // this.$router.replace(this.getRouteParam(this.model,1));//进入导航页面，加载产品查询的第一个选项
    this.headerHandle(this.menuList[1].index);
  }
}
</script>

<style scoped>

a{
  text-decoration: none;
}

.el-menu-item{
  user-select: none;
}
#root_page{
  height: 100%;
  width: 100%;
  position: absolute;
  overflow-y: hidden;
}

.nav_header{
  padding-left: 160px;
  text-decoration:none;
}
.router-link-active {
  text-decoration: none;
}
.nav_aside{
  border-right: none;
}
.aside-enter-active{
  animation:animation 0.5s linear;
}
.aside-leave-active{
  animation:animation 0.5s linear reverse;
}
@keyframes animation{
  from{
    transform:translateX(-100%);
  }
  to{
    transform:translateX(0);
  }

}

.el-aside{
  padding: 30px 5px;
  border-top: 1px #1b6d85 ;
  background-color:#545c64;
}
.el-main{
  overflow: hidden;
  max-height: calc(100vh - 61px - 60px);
}
.headView{
  z-index: 999;
  display: inline-block;
  margin: 20px ;
  left: 25px;
  position: fixed;
  transition: all 0.5s linear;
}
.headView_scale{
  margin: 5px 20px ;
  transform: scale(0.7,0.7);
  position: fixed;
  transition: all 0.5s linear;
}
.right_item{
  float: right;
}
.el-container{
  height: 100%;
  margin-top: -1px;
  position: relative;
}
.main{
  position: fixed;
  width: calc(100% - 200px);
  max-height: calc(100vh - 61px);
  right: 0;
  transition: width 0.5s linear;
}
.main_scale{
  width: 100% ;
  transition: width 0.5s linear;
}

.footer_page{
  user-select: none;
  height: 9rem;
  line-height: 9rem;
  width: 76%;
  left: 15%;
  bottom: 0;
  text-align: center;
  position: fixed;
  font-family: 微软雅黑, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: rgb(149, 165, 166);
}

</style>
